import React from 'react';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { AgreementsProvider } from './context/agreements-context';
import { AgreementsComponent } from './agreements-component';

export function AgreementsFactory() {
  return (
    <BaseLayoutFactory>
      <AgreementsProvider>
        <AgreementsComponent />
      </AgreementsProvider>
    </BaseLayoutFactory>
  );
}
